/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { SelectField, typography2 } from '@coursera/cds-core';
import type { SelectFieldProps } from '@coursera/cds-core';

const styles = {
  dropdown: css`
    display: flex;
    background-color: transparent;
    flex-shrink: 0;
    padding: var(--cds-spacing-50);

    .cds-input-root {
      border-radius: var(--cds-border-radius-400);
      margin-top: 0;
      height: 32px;
      width: fit-content;

      svg {
        height: 16px;
        width: 16px;
      }

      fieldset {
        border-color: var(--cds-color-neutral-stroke-primary);
        border-radius: var(--cds-border-radius-400);
      }

      .cds-input-input {
        font: ${typography2.actionSecondary.font} !important;
        letter-spacing: ${typography2.actionSecondary.letterSpacing} !important;
        align-content: center;

        :hover,
        :active {
          color: var(--cds-color-interactive-primary-hover) !important;
          border-radius: var(--cds-border-radius-400);
        }
      }
    }

    .cds-select-focusVisible::before {
      top: -2px !important;
      left: -2px !important;
      right: -2px !important;
      bottom: -2px !important;
      border-radius: var(--cds-border-radius-400) !important;
    }
  `,
};

const RoundedSelectField = ({ children, ...selectFieldProps }: SelectFieldProps) => {
  return (
    <SelectField {...selectFieldProps} css={styles.dropdown}>
      {children}
    </SelectField>
  );
};

export default RoundedSelectField;
